import { ApolloClient } from 'apollo-client';
import { useMemo } from 'react';
import { apolloCache } from './apollo-cache';
import { useApolloLink } from './apollo-link';

export const useInitialApolloClient = () => {
  const link = useApolloLink();

  return useMemo(
    () =>
      new ApolloClient({
        link,
        cache: apolloCache,
        name: 'Gibbs',
        version: '1.0',
        defaultOptions: {
          watchQuery: { fetchPolicy: 'cache-and-network' },
        },
      }),
    [link]
  );
};
